<template>
  <div id="app">
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'app',
  data () {
    return {
    }
  },
  mounted(){
    console.log(this.$route.fullPath);
    let vars = this.$route.fullPath.split("?")[1].replace('amp;','').replace('amp%3B','');
    this.goMini(vars)
    // console.log(vars);
    // let url = "https://jd-service-dev-ssl.devops-jdp.com/plat-qnr/qnr/updateUserJoinStatus?"+vars;
    // this.updateUserJoinStatus(url);
  },
  methods:{
    goMini(param){
      //回到小程序
      wx.miniProgram.redirectTo({
        url:'/pages/index/review/review?'+param,
        success: function(){
          console.log('success')
        },
        fail: function(){
          console.log('跳转回小程序的页面fail');
        },
      });
    },

    updateUserJoinStatus(url){
      fetch(url)
      .then(function(response) {
        return response.json();
      })
      .then(response => {
        // console.log(myJson) // true
        let sendType = -9;
        let amount = 0;
        if(response.status=200){
          amount = response.result.amount==null?0:response.result.amount;
          sendType = response.result.sendType;
        }
        console.log('开始回调');
        wx.miniProgram.redirectTo({
          url:'/pages/index/review/review?sendType='+ sendType+'&amount='+amount,
              success: function(){
                console.log('success')
                },
              fail: function(){
                console.log('跳转回小程序的页面fail');
            },
        });
        // }

        //  alert("重回小程序")
        //   //跳回小程序
        //   wx.miniProgram.navigateTo({url: '/pages/mine/winning/winningRecord'})
      }).catch(error => {
        wx.miniProgram.redirectTo({
          url:'/pages/index/review/review?sendType=1&amount=0.0',
          success: function(){
            console.log('success')
          },
          fail: function(){
            console.log('跳转回小程序的页面fail');
          },
        });
      });
    }

  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/page/QnrFinish/Ref.vue